import React, { useState } from 'react';
import DataTable from '../components/DataTable/DataTable';
import './ProductsPage.css';

const ProductsPage = () => {
  const [activeTab, setActiveTab] = useState('prime');

  return (
    <div className="products-wrapper">
      <div className="tabs">
        <div
          className={`tab ${activeTab === 'fortis' ? 'active' : ''}`}
          onClick={() => setActiveTab('fortis')}
        >
          Fortis
        </div>
        <div
          className={`tab ${activeTab === 'prime' ? 'active' : ''}`}
          onClick={() => setActiveTab('prime')}
        >
          Prime
        </div>
      </div>
      <div className="tab-content">
        {activeTab === 'prime' ? (
          <DataTable />
        ) : (
          <div className="placeholder"><strong>🔧Я НЕ УСПЕВАЮ ПИСАТЬ КОД ВЕЗДЕ, ПОЭТОМУ ТУТ ПОКА ПУСТО🔧</strong></div>
        )}
      </div>
    </div>
  );
};

export default ProductsPage;
